import dayjs from "dayjs";

export default function getGreetings() {
    const currentHour = dayjs().hour();

    if (currentHour >= 0 && currentHour < 12) {
        return "Good morning,";
    } else if (currentHour >= 12 && currentHour < 16) {
        return "Good afternoon,";
    } else if (currentHour >= 16 && currentHour < 24) {
        return "Good evening,";
    }
}